// Static data for the Abrolhos 2026 expedition

export const CONTACT = {
  name: "Lucas Agostini Figueró",
  phone: "(71) 99981-6915",
  whatsapp: "5571999816915",
  email: "lucasapecatu@gmail.com",
  city: "Caravelas, Bahia",
};

export const LOGO_URL = "/assets/apecatu-logo.jpg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1674183402855-5febad1812e6?fm=jpg&q=85&w=2400&auto=format&fit=crop",
  // Real ZEUS catamaran photos (file names are intentionally swapped to match semantic use)
  catamaran: "/assets/zeus-aerial.jpg",
  zeusAerial: "/assets/zeus-exterior.jpg",
  zeusCabinCasal: "/assets/zeus-quarto-casal.jpg",
  zeusCabinTriplo: "/assets/zeus-quarto-triplo.jpg",
  zeusSala: "/assets/zeus-sala-estar.jpg",
  // Legacy fallbacks for other sections
  cabin: "/assets/zeus-quarto-casal.jpg",
  shipwreck: "https://images.pexels.com/photos/15463400/pexels-photo-15463400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  lighthouse: "https://static.prod-images.emergentagent.com/jobs/9278a1d8-e433-46cc-a0f1-fafa76d840a2/images/0e58dd69c4cc2c18d83637d888e9849f2279bef4c392a2780dc17655fa838470.png",
  whaleSurface: "https://images.unsplash.com/photo-1568430462989-44163eb1752f?auto=format&fit=crop&w=1400&q=80",
  scubaDiver: "/assets/night-dive-octopus.jpg",
  reef: "https://images.unsplash.com/photo-1546026423-cc4642628d2b?auto=format&fit=crop&w=1400&q=80",
  kayak: "/assets/sup-paddle.png",
  sunset: "/assets/abrolhos-island.png",
  underwater: "/assets/chapeirao.png",
  whaleTail: "https://images.unsplash.com/photo-1583212292454-1fe6229603b7?auto=format&fit=crop&w=1400&q=80",
};

export const PACKAGES = [
  {
    id: "2d1n",
    duration: "2 dias",
    nights: "1 pernoite",
    badge: "Quick Escape",
    withDive: {
      dives: "5 mergulhos · sendo 1 em naufrágio + 1 noturno",
      diveDetail: "4 diurnos · 1 noturno · 1 naufrágio",
      icmbio: 12,
      icmbioForeign: 24,
    },
    withoutDive: {
      activities: "Apneia, caiaque, SUP, ilhas",
      icmbio: 12,
      icmbioForeign: 24,
    },
  },
  {
    id: "3d2n",
    duration: "3 dias",
    nights: "2 pernoites",
    badge: "Imersão clássica",
    withDive: {
      dives: "8 mergulhos · 2 em naufrágios + 2 noturnos",
      diveDetail: "6 diurnos · 2 noturnos · 2 naufrágios",
      icmbio: 24,
      icmbioForeign: 48,
    },
    withoutDive: {
      activities: "Apneia, caiaque, SUP, ilhas",
      icmbio: 24,
      icmbioForeign: 48,
    },
  },
  {
    id: "4d3n",
    duration: "4 dias",
    nights: "3 pernoites",
    badge: "Mais escolhido",
    highlight: true,
    withDive: {
      dives: "11 mergulhos · 3 em naufrágios + 3 noturnos",
      diveDetail: "8 diurnos · 3 noturnos · 3 naufrágios",
      icmbio: 36,
      icmbioForeign: 72,
    },
    withoutDive: {
      activities: "Apneia, caiaque, SUP, ilhas",
      icmbio: 36,
      icmbioForeign: 72,
    },
  },
];

// Preço por pessoa (R$), por ano e por pacote. Fonte única dos valores exibidos no site e no PDF.
// ICMBio, mergulhos e atividades não mudam entre os anos e continuam em PACKAGES.
export const PRICES_BY_YEAR = {
  2026: {
    "2d1n": { withDive: 3000, withoutDive: 2400 },
    "3d2n": { withDive: 4000, withoutDive: 3000 },
    "4d3n": { withDive: 4800, withoutDive: 3800 },
  },
  2027: {
    "2d1n": { withDive: 3150, withoutDive: 2550 },
    "3d2n": { withDive: 4250, withoutDive: 3250 },
    "4d3n": { withDive: 5000, withoutDive: 4000 },
  },
};

// mode: "dive" | "no-dive"
export const priceFor = (pkg, mode, year) =>
  PRICES_BY_YEAR[year]?.[pkg.id]?.[mode === "dive" ? "withDive" : "withoutDive"];

export const BOAT_SPECS = [
  { label: "Modelo", value: "Catamarã ZEUS" },
  { label: "Tamanho", value: "50 pés" },
  { label: "Propulsão", value: "Motor" },
  { label: "Capacidade", value: "11 hóspedes" },
  { label: "Cabines", value: "4 cabines" },
  { label: "Banheiros", value: "4 (2 nas suítes + 2 externos)" },
];

export const CABINS_DETAIL = [
  "1 suíte de casal (com banheiro privativo)",
  "1 suíte tripla (com banheiro privativo)",
  "1 quarto de casal",
  "1 quarto quádruplo",
];

export const BOAT_FEATURES = [
  "Infraestrutura de recarga de cilindros",
  "Tripulação completa: Mestre, Marinheiro e Cozinheira",
  "Staff de mergulho com Instrutores",
  "Sala de estar com TV",
  "Bote salva-vidas inflável e coletes",
  "Oxigênio e kit de primeiros socorros",
  "Capacidade de 3.500 litros de água",
  "Equipamento eletrônico completo de navegação",
  "Banheiros feminino e masculino independentes",
];

export const EXPERIENCES = [
  {
    title: "Mergulhos em Naufrágios",
    desc: "Explore navios afundados nos principais pontos de mergulho do parque marinho.",
    img: "shipwreck",
  },
  {
    title: "Chapeirões Vivos",
    desc: "Formações de coral endêmicas únicas no mundo, exclusivas de Abrolhos.",
    img: "underwater",
  },
  {
    title: "Mergulhos Noturnos",
    desc: "A vida marinha em sua versão mais misteriosa, sob feixes de lanterna.",
    img: "scubaDiver",
  },
  {
    title: "Baleias Jubarte",
    desc: "Saltos e cantos das jubartes vistos do convés durante a navegação.",
    img: "whaleSurface",
  },
  {
    title: "Ilha de Santa Bárbara",
    desc: "Visita autorizada pela Marinha ao farol histórico e pôr do sol cinematográfico.",
    img: "lighthouse",
  },
  {
    title: "Apneia, Caiaque & SUP",
    desc: "Para quem não mergulha: snorkel, stand up paddle, caiaque e muita diversão.",
    img: "kayak",
    objectPosition: "center 85%",
  },
];

export const EXPERIENCE_INTRO = "Entre mergulhos diurnos em chapeirões, naufrágios históricos e noturnos, e também baleias jubarte saltando ao lado do catamarã durante a navegação até o arquipélago. Abrolhos é um daqueles lugares que não cabem em fotos — mas a gente tenta.";

export const INCLUDED = [
  "Hospedagem a bordo do Catamarã ZEUS",
  "Todas as refeições (café, almoço, lanche, jantar, frutas, sobremesas)",
  "Roupas de cama e banho",
  "Tripulação completa e staff de mergulho",
  "Visita à Ilha de Santa Bárbara (com autorização da Marinha)",
  "Mergulhos conforme o pacote escolhido",
];

export const NOT_INCLUDED = [
  "Passagens aéreas (consulte opções de aeroportos)",
  "Transfer terrestre",
  "Hospedagem em Caravelas na chegada e saída",
  "Equipamentos de mergulho (locação disponível R$ 40,00/diária)",
  "Bebidas alcoólicas",
  "Ingresso ICMBio (sob taxa do parque)",
];

export const EXTRAS = [
  { label: "Suíte (acréscimo por cabine)", value: "R$ 250,00" },
  { label: "Locação de Equipamento (colete, roupa, regulador ou lanterna)", value: "R$ 40,00 / peça / diária" },
  { label: "Batismo Diurno", value: "R$ 300,00" },
  { label: "Batismo Noturno (com lanterna)", value: "R$ 200,00" },
  { label: "Curso Open Water", value: "R$ 1.800,00" },
  { label: "Curso Avançado", value: "R$ 1.800,00" },
];

export const PAYMENT_INFO = {
  highlight: "3x no cartão sem juros",
  items: [
    "Parcelamento em até 3x sem juros no cartão de crédito",
    "À vista no PIX, débito ou crédito",
    "Em até 3 pagamentos: à vista / 30 / 60 dias do embarque",
    "20% de entrada para confirmação da reserva",
  ],
};

export const CALENDAR_2026 = [
  {
    month: "Julho",
    dates: [
      { range: "30/07 a 02/08", days: 4, status: "available" },
    ],
  },
  {
    month: "Agosto",
    dates: [
      { range: "11 a 13", days: 3, status: "available" },
      { range: "18 a 20", days: 3, status: "available" },
      { range: "22 a 25", days: 4, status: "available" },
      { range: "30/08 a 01/09", days: 3, status: "available" },
    ],
  },
  {
    month: "Setembro",
    dates: [
      { range: "11 a 13", days: 3, status: "available" },
      { range: "14 a 16", days: 3, status: "available" },
      { range: "18 a 21", days: 4, status: "available" },
      { range: "29/09 a 01/10", days: 3, status: "available" },
    ],
  },
  {
    month: "Outubro",
    dates: [
      { range: "09 a 12", days: 4, status: "available" },
      { range: "16 a 18", days: 3, status: "available" },
      { range: "20 a 21", days: 2, status: "available" },
      { range: "23 a 26", days: 4, status: "available" },
      { range: "30/10 a 01/11", days: 3, status: "available" },
    ],
  },
  {
    month: "Novembro",
    dates: [
      { range: "06 a 08", days: 3, status: "available" },
      { range: "13 a 15", days: 3, status: "available" },
      { range: "27 a 29", days: 3, status: "available" },
    ],
  },
  {
    month: "Dezembro",
    dates: [
      { range: "04 a 06", days: 3, status: "available" },
      { range: "11 a 13", days: 3, status: "available" },
      { range: "18 a 20", days: 3, status: "available" },
      { range: "27 a 28", days: 2, status: "available" },
      { range: "29/12 a 01/01", days: 4, status: "available", special: "Réveillon" },
    ],
  },
];

export const CALENDAR_2027 = [
  {
    month: "Janeiro",
    dates: [
      { range: "03 a 05", days: 3, status: "available" },
      { range: "08 a 10", days: 3, status: "available" },
      { range: "19 a 21", days: 3, status: "available" },
      { range: "22 a 25", days: 4, status: "available" },
      { range: "26 a 28", days: 3, status: "available" },
    ],
  },
  {
    month: "Fevereiro",
    dates: [
      { range: "12 a 14", days: 3, status: "available" },
      { range: "19 a 22", days: 4, status: "available" },
      { range: "26 a 28", days: 3, status: "available" },
    ],
  },
  {
    month: "Março",
    dates: [
      { range: "05 a 07", days: 3, status: "available" },
      { range: "12 a 14", days: 3, status: "available" },
      { range: "19 a 22", days: 4, status: "available" },
      { range: "26 a 28", days: 3, status: "available" },
    ],
  },
];

export const YEARS = [2026, 2027];

export const CALENDARS_BY_YEAR = {
  2026: CALENDAR_2026,
  2027: CALENDAR_2027,
};

// Meses que NÃO aparecem no site nem no PDF (saídas já realizadas).
// Os dados continuam em CALENDAR_2026 porque o admin (/paineldm) e as reservas antigas ainda usam essas chaves.
// Para ocultar ou reexibir um mês, basta editar esta lista.
export const HIDDEN_PUBLIC_MONTHS = {
  2026: ["Julho", "Agosto", "Setembro"],
};

// Calendário público: o mesmo de CALENDARS_BY_YEAR, sem os meses ocultos.
export const PUBLIC_CALENDARS_BY_YEAR = Object.fromEntries(
  Object.entries(CALENDARS_BY_YEAR).map(([year, months]) => [
    year,
    months.filter((m) => !(HIDDEN_PUBLIC_MONTHS[year] || []).includes(m.month)),
  ])
);

export const CABINS = [
  { key: "cabineCasal", label: "Cabine Casal", beds: 2, position: "top-left" },
  { key: "suiteTripla", label: "Suíte Tripla", beds: 3, position: "top-right" },
  { key: "suiteCasal", label: "Suíte Casal", beds: 2, position: "bottom-left" },
  { key: "cabineQuadrupla", label: "Cabine Quádrupla", beds: 4, position: "bottom-right" },
];

// Default occupancy example (all free). Real values come from the backend.
export const DEFAULT_OCCUPANCY = {
  cabineCasal: [false, false],
  suiteTripla: [false, false, false],
  suiteCasal: [false, false],
  cabineQuadrupla: [false, false, false, false],
};

// All new dates start with 11/11 free (empty object = no pre-populated occupancy)
export const EXAMPLE_OCCUPANCY_BY_KEY = {};

// 2026 mantém o formato legado (compatível com o que já está no banco).
// Demais anos levam o ano como prefixo para evitar colisão de chaves.
export const dateKey = (month, range, year = 2026) =>
  year === 2026 ? `${month}|${range}` : `${year}|${month}|${range}`;

// Map days → package id
export const PACKAGE_ID_BY_DAYS = {
  2: "2d1n",
  3: "3d2n",
  4: "4d3n",
};